import { SchoolHomeSetting } from './SchoolHomeSetting';
export default SchoolHomeSetting;
